// ** react imports
import React, { useMemo } from 'react';

// ** enums imports
import { BUTTON_THEMES } from '../../../../enums/common';

const LoadingButton = props => {
  // props
  const { isLoading, theme, type, onClick, children } = props;

  // hooks
  const buttonTheme = useMemo(() => {
    switch (theme) {
      case BUTTON_THEMES.PRIMARY:
        return 'bg-violet-600 hover:bg-violet-700 text-white dark:bg-violet-600 dark:hover:bg-violet-700 disabled:bg-violet-400 dark:disabled:bg-violet-400 focus:ring-violet-500';
      case BUTTON_THEMES.SECONDARY:
        return 'bg-white hover:bg-gray-50 border border-gray-200 text-gray-800 dark:bg-gray-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 dark:text-gray-200 disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:text-gray-400 dark:disabled:text-gray-500 focus:ring-gray-500';
      case BUTTON_THEMES.TERTIARY:
        return 'bg-transparent hover:bg-gray-100 border border-gray-200 text-violet-600 dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 dark:text-gray-200 disabled:text-gray-400 dark:disabled:text-gray-500 focus:ring-violet-500';
      case BUTTON_THEMES.DANGER:
        return 'bg-red-600 hover:bg-red-700 text-white dark:bg-red-600 dark:hover:bg-red-700 disabled:bg-red-400 dark:disabled:bg-red-400 focus:ring-red-500';
      case BUTTON_THEMES.WARNING:
        return 'bg-amber-500 hover:bg-amber-600 text-white dark:bg-amber-500 dark:hover:bg-amber-600 disabled:bg-amber-400 dark:disabled:bg-amber-400 focus:ring-amber-500';
      case BUTTON_THEMES.SUCCESS:
        return 'bg-emerald-600 hover:bg-emerald-700 text-white dark:bg-emerald-600 dark:hover:bg-emerald-700 disabled:bg-emerald-400 dark:disabled:bg-emerald-400 focus:ring-emerald-500';
      default:
        return 'bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 focus:ring-gray-500';
    }
  }, [theme]);

  return (
    <div className="">
      {isLoading ? (
        <button
          className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white disabled:border-gray-300 dark:disabled:border-gray-700 disabled:bg-white dark:disabled:bg-gray-800 disabled:text-gray-300 dark:disabled:text-gray-600 disabled:cursor-not-allowed"
          disabled
        >
          <svg
            className="animate-spin fill-current shrink-0"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
          </svg>
          <span className="ml-2">Loading</span>
        </button>
      ) : (
        <button
          type={type}
          onClick={onClick}
          className={`btn ${buttonTheme} whitespace-nowrap`}
        >
          {children}
        </button>
      )}
    </div>
  );
};

export default LoadingButton;
